import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRDocumentPartnerName = createSelector(
  [selectQbrState],
  (state) => state.documentPartnerName
)
